import React, { useState, useEffect } from 'react';
import API from '../../Services/API';
import TimeAgo from '../Formatting/TimeAgo';
import { classNames } from '../../Services/helpers';
import Entries from './Entries';
import Loading from '../Loading';
import Icon from '../Icons/Icon';
import { useAssistantContext } from './Provider';

const PreviousConversations = () => {
    const {previousConversations} = useAssistantContext();


    if (!previousConversations?.length) {
        return null;
    }

    return <div className="flex flex-col gap-2 mb-4">
        {previousConversations.sort((a, b) => new Date(a.startedAt) - new Date(b.startedAt)).map((conversation) => {
            if (!conversation.subject) {
                return null;
            }

            return <Conversation key={conversation.id} conversation={conversation} />
        })}
    </div>
}

const Conversation = ({ conversation }) => {
    const [expanded, setExpanded] = useState(false);
    const [fullConversation, setFullConversation] = useState(null);

    useEffect(() => {
        if (expanded && !fullConversation) {
            API.get(`/assistant/${conversation.id}`).then(setFullConversation);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [expanded]);

    return <div className={classNames(
            'p-2 rounded-lg cursor-pointer transition-all duration-300',
            expanded ? 'border-2 border-blue-200 bg-slate-50 dark:bg-slate-800 text-slate-900 dark:text-slate-100' : 'bg-blue-100 dark:bg-blue-900 text-slate-900 dark:text-slate-100',
            expanded ? 'max-h-auto' : 'max-h-[4em]',
        )}
        onClick={() => setExpanded(!expanded)}
    >
        <div className="flex flex-row justify-between items-center">
            <div>
                <span className={expanded ? 'font-bold' : ''}>{conversation.subject}</span><br />
                <TimeAgo dateTime={conversation.startedAt} className="text-muted text-sm" />
            </div>
            <div>
                <Icon icon={expanded ? 'DownChevron' : 'LeftChevron'} className="w-4 h-4 fill-muted" />
            </div>
        </div>

        {expanded && <div className="mt-2 flex flex-col gap-2">
            {fullConversation ? <Entries entries={fullConversation.entries} /> : <Loading center />}
        </div>}
    </div>
}

export default PreviousConversations;
